import { observer } from "mobx-react-lite";
import { StageTaskType } from "@/store/Lifecycle/constants";
import { useTranslation } from "react-i18next";
import { EPInput } from "@/comp";
import { AutoSaverFormItem } from "./AutoSaverFormItem";
import { getTaskFieldMetadata } from "./constants";
import { useTask } from "./Provider";
import { computeValidateStatus } from "./utils";


export const TextField = observer(() => {
    const task = useTask<StageTaskType.Text>();
    const { name, value, validateStatus, help, isSaving, isReadOnly, required } = getTaskFieldMetadata(task);
    const { t } = useTranslation();
    
    const computedValidateStatus = computeValidateStatus(value, validateStatus);
    
    return (
        <AutoSaverFormItem 
            name={name} 
            initialValue={value} 
            className='stage-task-input-field' 
            hasFeedback 
            validateStatus={computedValidateStatus} 
            help={t(help)}
            required={required}
        >
            <EPInput 
                className='stage-task-input'
                value={value} 
                disabled={isReadOnly || isSaving}
            />
        </AutoSaverFormItem>
    );
});